'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CamOverlay = require('../CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

var _CamRewind = require('../CamRewind');

var _CamRewind2 = _interopRequireDefault(_CamRewind);

var _AspectRatioContent = require('../AspectRatioContent');

var _AspectRatioContent2 = _interopRequireDefault(_AspectRatioContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamNighttime = function CamNighttime(_ref) {
  var message = _ref.message,
      rewindUrl = _ref.rewindUrl,
      stillUrl = _ref.stillUrl;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-nighttime' },
    rewindUrl ? _react2.default.createElement(_CamRewind2.default, { href: rewindUrl }) : null,
    _react2.default.createElement(
      _AspectRatioContent2.default,
      null,
      _react2.default.createElement(_CamOverlay2.default, { backgroundImage: 'url(' + stillUrl + ')' }),
      _react2.default.createElement(
        'div',
        { className: 'quiver-cam-nighttime__message' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-nighttime__message__header' },
          message
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-nighttime__message__subtext' },
          'Enjoy a ',
          _react2.default.createElement(
            'a',
            { href: rewindUrl },
            'Cam Rewind'
          )
        )
      )
    )
  );
};

CamNighttime.propTypes = {
  stillUrl: _propTypes2.default.string,
  message: _propTypes2.default.string,
  rewindUrl: _propTypes2.default.string
};

CamNighttime.defaultProps = {
  message: 'Live camera stream unavailable during nighttime hours',
  rewindUrl: null
};

exports.default = CamNighttime;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamNighttime/CamNighttime.js
// module id = 535
// module chunks = 11